module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.af7ae505a9eed503f8b8e6982036873e.woff2?";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 1293
// module chunks = 9